import { PaymentType, TransactionStatus, ProductType } from '@ace-clublabs/payment-types';
import { ProductSubType } from './enums';

export enum ErrorSeverity {
  HARD = 'hard',
  SOFT = 'soft',
}

export enum ErrorType {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  MANIFEST_ERROR = 'MANIFEST_ERROR',
  SESSION_TIMEOUT = 'SESSION_TIMEOUT',
  AUTH_ERROR = 'AUTH_ERROR',
  AUTOPAY_ERROR = 'AUTOPAY_ERROR',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  INVALID_PAYMENT_METHOD_ERROR = 'INVALID_PAYMENT_METHOD_ERROR',
  PBL_EXPIRED = 'PBL_EXPIRED',
  PBL_ERROR = 'PBL_ERROR',
  PBL_INCORRECT_PIN = 'PBL_INCORRECT_PIN',
  PBL_TOO_MANY_ATTEMPTS = 'PBL_TOO_MANY_ATTEMPTS',
  SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR',
  RATE_LIMITED = 'RATE_LIMITED',
}

export interface Error {
  errorMessage: string;
  errorType: ErrorType;
}

export interface IConfirmationApiRequest {
  transactionId: string;
  requestId: string;
  customerId: string;
}

export type IPaymentDetails = {
  paymentType: PaymentType;
  accountHolderName?: string;
  amountPaid?: number;
  autoPayStatus?: TransactionStatus;
  paymentStatus?: TransactionStatus;
  card?: {
    brand: string;
    last4: string;
    bin?: string;
    brandImageUrl?: string;
  };
  echeck?: {
    last4?: string;
    accountLast4?: string;
    routingNumber: string;
  };
};
export interface IConfirmationApiResponse {
  clubCode: string;
  confirmationNumber: string;
  paymentDetails: IPaymentDetails;
  productId: string;
  productType: ProductType;
  productPrefix?: string;
  productSubType?: ProductSubType;
}
